<template>
  <div class="OperationRecord">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="设备代码">
        <el-input v-model="searchForm.deviceCode"
                  placeholder="设备代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
    </el-form>
    <el-table class="dataTable"
              v-loading="dataListLoading"
              :data="dataList"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              border>
      <el-table-column label="操作设备代码"
                       prop="operateObjectCode">
      </el-table-column>
      <el-table-column label="操作内容"
                       prop="operateObjectName">
      </el-table-column>
      <el-table-column label="操作人"
                       prop="operateUserCode">
      </el-table-column>
      <el-table-column label="操作时间"
                       prop="operateTime">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="openDetailDialog(scope.row)">查看</el-button>
          <el-button size="mini"
                     type="danger"
                     @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageIndex"
                   :page-size="pageSize"
                   :page-sizes="[10, 20, 50, 100]"
                   :total="totalPage"
                   background
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle">
    </el-pagination>

    <!-- 操作信息详情 -->
    <el-dialog title="操作信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="操作设备代码："
                      prop="operateObjectCode">
          <span>{{ detailForm.operateObjectCode}}</span>
        </el-form-item>
        <el-form-item label="操作内容："
                      prop="operateObjectName">
          <span>{{ detailForm.operateObjectName}}</span>
        </el-form-item>
        <el-form-item label="操作人："
                      prop="operateUserCode">
          <span>{{ detailForm.operateUserCode}}</span>
        </el-form-item>
        <el-form-item label="操作时间："
                      prop="operateTime">
          <span>{{ detailForm.operateTime}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/OperationRecord.css'
export default {
  data() {
    return {
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 0,
      pageSize: 10,
      totalPage: 1,
      detailDialog: false,
      detailForm: {},
    }
  },

  computed: {},

  created() {
    let self = this

    self.getDataList()
  },

  mounted() {},

  methods: {
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      self.dataListLoading = true

      if (type == 'search') {
        self.pageIndex = 0
      }

      let str = {
        operateObjectCode: self.searchForm.deviceCode || '',
        operateObjectType: 3,
        operateType: 0,
        pageNow: self.pageIndex,
        pageSize: self.pageSize,
      }

      self.$axios
        ._getOperatingRecordList(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.content
            self.totalPage = datas.data.totalElements
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 操作信息弹窗
    openDetailDialog: function (row) {
      let self = this

      self.detailForm = row

      self.detailDialog = true
    },

    // 关闭 操作信息弹窗
    cancelDetailDialog: function () {
      let self = this

      // Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除操作记录
    handleDelete(row) {
      let self = this

      let ids = row.id
      let operateObjectCode = row.operateObjectCode
      let operateObjectType = 3

      let str = `?ids=${ids}&operateObjectCode=${operateObjectCode}&operateObjectType=${operateObjectType}`

      self
        .$confirm(
          `是否确认要删除 "${row.operateObjectCode}" 操作记录？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(function () {
          return self.delOperatingRecord(str)
        })
        .then((data) => {})
    },

    delOperatingRecord(code) {
      let self = this

      self.$axios
        ._deleteOperatingRecord(code)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>



// WEBPACK FOOTER //
// src/views/OperationRecord.vue